import React from 'react';
import { Input } from 'reactstrap';
import './index.scss';
import { useSelector } from 'react-redux';

const RevisionDropdown = ({ options, handleVal, val = '', original, loader, inputDisabled }) => {
    const handleOnChange = (value) => {
        handleVal(value);
    };

    const revisionSelected = useSelector((state) => state.document?.revisionSelected);
    // console.log(revisionSelected)
    // console.log(options)
    return (
        <div className={`version-dropdown${!loader ? " disable" : ""}`}>
            <Input disabled={inputDisabled} type="select" name="select" onChange={($event) => { handleOnChange($event.target.value); }} className="form-select">
            {<option value={original}>
                    {'Original'}</option>}
                {options && options.map((item, index) => {
                    if (item.revision) {
                        return (<option key={index} selected={item._id == val} value={item._id}>
                            {item.revision ? 'Revision ' + (index+1) : 'Original'}</option>);

                    }

                })}
            </Input>
        </div>
    )
}

export default RevisionDropdown;